<template>
    <i
        class="o-icon"
        :class="[
            `o-icon--${icon}`,
            size ? `o-icon--${size}` : ''
        ]"
    >

        <span
            v-if="fallback"
            class="o-icon__fallback"
        >
            {{ icon.charAt(0).toUpperCase() }}
        </span>

        <svg
            v-else
            :class="'svg-' + icon"
        >
            <title v-if="title">{{ title }}</title>
            <use v-bind:xlink:href="'/assets/svg/sprite.svg#svg-' + icon"></use>
        </svg>

    </i>
</template>

<script>/* eslint-disable */

	export default {
        name: 'Icon',
        props: {
            icon: {
                type: String,
                required: true
            },
            title: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: ''
            },
            fallback: {
                type: Boolean | Object,
                default: false
            }
        }
	}
</script>

<style scoped>
</style>
